import { configureStore, createSlice } from "@reduxjs/toolkit";

const cookingSessionsSlice = createSlice({
  name: "cookingSessions",
  initialState: [],
  reducers: {
    addCookingSession: (state, action) => {
      state.push(action.payload);
    },
  },
});

const store = configureStore({
  reducer: {
    cookingSessions: cookingSessionsSlice.reducer,
  },
});

const startingState = store.getState();
// console.log(JSON.stringify(startingState));

store.dispatch(cookingSessionsSlice.actions.addCookingSession({}));
// console.log(JSON.stringify(store.getState()));

export { store };
export const { addCookingSession } = cookingSessionsSlice.actions;
